import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PoModule } from '@po-ui/ng-components';
import { RPAsAnalisePendenciaComponent } from './rpas-analise-pendencia.component';

@NgModule({
  declarations: [RPAsAnalisePendenciaComponent],
  exports: [RPAsAnalisePendenciaComponent],
  imports: [CommonModule, FormsModule, RouterModule, PoModule]
})
export class RpasAnalisePendenciaModule {}
